import { SetStateAction } from "react";
import Markdown from "react-markdown";
import { Button, Card, CardBody, CardHeader } from "reactstrap";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import stripJsonComments from "strip-json-comments";
import { ReactGlobals, TreeNode } from "../Types";

function parseLine(line_node_content: string) {
  let dataKey = "name missing";
  let stroke = "#82ca9d";

  try {
    const new_args = JSON.parse(stripJsonComments(line_node_content));
    let new_dataKey = new_args["dataKey"];
    if (typeof new_dataKey === "string") {
      dataKey = new_dataKey;
    }
    let new_stroke = new_args["stroke"];
    if (typeof new_stroke === "string") {
      stroke = new_stroke;
    }
  } catch (e) {
    console.log("error parsing json", e);
  }

  return (
    <Line
      type="monotone"
      dataKey={dataKey}
      stroke={stroke}
      activeDot={{ r: 8 }}
    />
  );
}

const LineChartNode = (
  node: TreeNode,
  globals: ReactGlobals,
  load_node: (new_id: string, new_type: string) => void,
  handleTempContentChange: (event: {
    target: { value: SetStateAction<string> };
  }) => void
) => {
  let width = 800;
  let height = 400;
  let data: any[] | undefined = [];

  node.Children.forEach((child: TreeNode) => {
    if (child.Name === "width") {
      width = +child.Content;
    } else if (child.Name === "height") {
      height = +child.Content;
    } else if (child.Type === "Data") {
      data = JSON.parse(stripJsonComments(child.Content));
    }
  });

  return (
    <Card key={Math.random().toString() + node.ID}>
      <CardHeader>
        <Button
          outline
          disabled={node.ID === globals.node.ID}
          onClick={() => {
            load_node(node.ID, node.Type);
          }}
        >
          {node.ID === globals.node.ID ? globals.temporaryName : node.Name}
        </Button>
      </CardHeader>
      <CardBody>
        <Markdown remarkPlugins={[remarkGfm, remarkBreaks]}>
          {node.ID === globals.node.ID
            ? globals.temporaryContent
            : node.Content}
        </Markdown>
        <LineChart
          width={width}
          height={height}
          data={data}
          margin={{
            top: 30,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="x" />
          <YAxis />
          <Tooltip />
          <Legend />
          {node.Children.filter((child) => child.Type === "Line").map((child) =>
            parseLine(child.Content)
          )}
        </LineChart>
      </CardBody>
    </Card>
  );
};

export function add_LineChart_to_dicts(
  constuctor_dict: Map<
    string,
    (
      node: TreeNode,
      globals: ReactGlobals,
      load_node: (new_id: string) => void,
      handleTempContentChange: (event: {
        target: { value: SetStateAction<string> };
      }) => void
    ) => JSX.Element
  >,
  type_prompt_dict: Map<string, string[]>,
  type_adding_dict: Map<string, string[]>,
  type_depth_dict: Map<string, number>
) {
  constuctor_dict.set("LineChart", LineChartNode);
  type_prompt_dict.set("LineChart", []);
  type_adding_dict.set("LineChart", ["Line"]);
  type_depth_dict.set("LineChart", 100);
}

export default LineChartNode;
